<template>
    <div>
        <h1 class="display-heading">Invite Patients</h1>

        <p>Invite your existing patients to join {{ companyName }} Platform!</p>

        <div class="card mb-3">
            <div class="card-body">
                <h5>
                    Invite Patient
                </h5>
                <p>
                    Enter the patient details here. An invitation e-mail will be sent out to the patient to join our platform!
                </p>

                <single-user-invite @userInvited="triggerUpdateInvitationList"></single-user-invite>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <h5>
                    Bulk Invite Patients
                </h5>
                <p>
                    Got a long list of patients to invite? Try bulk invitation here.
                </p>
                <router-link class="btn btn-primary btn-primary-insv" :to="{'name': 'doctor-bulk-invite-patient'}">
                    Bulk Invite Patients
                </router-link>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <h5>
                    Invitation Report
                </h5>
                <p>
                    All the patients that you've invited in the past will show in this list.
                </p>

                <invitation-report ref="invitationReport"></invitation-report>
            </div>
        </div>
    </div>
</template>

<script>
import singleUserInvite from '@/components/user-invite/doctor-single';
import invitationReport from '@/components/user-invite/doctor-patient-invitation-report';
export default {
    'name': 'DoctorInvitePatients',
    'components': {
        singleUserInvite,
        invitationReport
    },
    'computed': {
        companyName () {
            return this.$store.state.operator.companyNameDisplay;
        }
    },
    'methods': {
        triggerUpdateInvitationList () {
            this.$refs.invitationReport.refreshList();
        }
    }
};
</script>
